import { configureStore } from '@reduxjs/toolkit';
import chatReducer from './chat/slice';
import documentReducer from './document/slice';
import companyReducer from './company/slice';
import promptReducer from './prompt/slice';
import userReducer from './user/slice';
import evaluationReducer from './evaluation/slice';
import benchmarkReducer from './benchmark/slice';
import appReducer from './app/slice';
import summaryTestReducer from './summaryTest/slice';
import documentUploadReducer from './documentUpload/slice';
import researchReducer from './research/slice';
import signalSearchReducer from './search/slice';

export const store = configureStore({
  reducer: {
    app: appReducer,
    chat: chatReducer,
    document: documentReducer,
    company: companyReducer,
    prompt: promptReducer,
    user: userReducer,
    evaluation: evaluationReducer,
    benchmark: benchmarkReducer,
    summaryTest: summaryTestReducer,
    documentUpload: documentUploadReducer,
    research: researchReducer,
    signalSearch: signalSearchReducer,
  },
  devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
